import {
  type StoryTextBlock,
  storyTextFromBlocks,
} from '@trilirivos/story-text';
import { TextBlock } from '../interfaces/textEditor.interface';

// TRIL-608: the flattening is now shared by server, web and mobile via @trilirivos/story-text.
//
// The three copies had diverged on four of six block types (TRIL-607). The web copy's Quote
// branch read `data.text ?? data.quote` — fields NOTHING writes — so every quote contributed an
// empty string and was filtered out: quoted content reached neither scoring nor the pre-publish
// safety gate (TRIL-609). The server had already fixed that under TRIL-87; the fix never
// crossed over, which is the argument for one implementation rather than three.
//
// Re-exported under the original name so existing call sites are unchanged.
export const extractTextFromBlocks = (
  textBlocks: TextBlock[] | null | undefined,
): string =>
  storyTextFromBlocks(textBlocks as StoryTextBlock[] | null | undefined);

// Pre-existing and currently exercised only by this file's test — kept verbatim rather than
// dropped, since removing it is unrelated to TRIL-608. Its `text` now comes from the shared
// flattening, so its wordCount/characterCount shift with the same contract change as everything
// else (quote content included, bullets and `[Code block: …]` wrappers gone).
export const getStoryMetadata = (textBlocks: any) => {
  const text = extractTextFromBlocks(textBlocks);
  const blockCounts: Record<string, number> = {};
  textBlocks.forEach((block: any) => {
    if (block.type) {
      blockCounts[block.type] = (blockCounts[block.type] || 0) + 1;
    }
  });

  return {
    totalBlocks: textBlocks.length,
    blockTypes: blockCounts,
    wordCount: text.split(/\s+/).filter((word) => word.length > 0).length,
    characterCount: text.length,
    estimatedReadingTime: Math.ceil(text.split(/\s+/).length / 200), // ~200 WPM
    hasImages: blockCounts['Image'] > 0,
    hasCode: blockCounts['Code'] > 0,
    hasLists: blockCounts['List'] > 0,
  };
};
